import { createAsyncThunk } from '@reduxjs/toolkit'
import { api, createRequestSlice } from 'utils'
import { Booth } from './types'
import { RootState } from '../../../store'

// TODO low priotiy
//  rename boothSlug to spaceSlug, for consistancy
//  move this to booth instead of booth/config, since its also used in jobs
export const fetchBooth = createAsyncThunk(
    'FETCH_BOOTH',
    ({ eventSlug, boothSlug }: { eventSlug: string; boothSlug: string }) => {
        const url = `/events/${eventSlug}/organizer/booths/${boothSlug}/`
        return api.get<Booth>(url)
    }
)

const fetchBoothSlice = createRequestSlice<Booth>(fetchBooth, 'fetchBoothSlice')

export const selectBooth = (state: RootState) => state.booth.config?.data
export const requestStatusSelector = (state: RootState) => state.booth.config?.status
export const selectBoothSlug = (state: RootState) => state.booth.config?.data?.slug
export const boothLogoSelector = (state: RootState) => state.booth.config?.data?.booth_logo
export const maxStaffSelector = (state: RootState) => state.booth.config?.data?.max_staff || 0

export default fetchBoothSlice.reducer
